import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemNotificationsChecklistsComponent } from './checklists/checklists.component';
import { ItemsListModule } from '../components/items-list/items-list.module';
import { SystemNotificationsAutosavedComponent } from './autosaved/autosaved.component';
import { SystemNotificationsTabsComponent } from './tabs/tabs.component';
import { MatTabsModule } from '@angular/material/tabs';
import { UtilitiesModule } from '../utilities/utilities.module';
import { SystemNotificationsCheckpointAnswerComponent } from './checkpoint-answer/checkpoint-answer.component';
import { ChecklistModule } from '../checklist/checklist.module';
import { SystemNotificationsService } from './system-notifications.service';
import { FiSystemNotificationsBlockComponent } from './notifications-block/notifications-block.component';
import { ChecklistsReminderService } from '@fi-app/system-notifications/checklists/checklists-reminder.service';
import { SystemNotificationsRequestAccessComponent } from './request-access/request-access.component';
import { SystemNotificationsFormsComponent } from './forms/forms.component';
import { SystemNotificationsTasksComponent } from './tasks/tasks.component';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { MatIconModule } from '@angular/material/icon';
import { UserRequestsAccessModule } from '@fi-app/user/fi-user-requests-list/fi-user-requests.module';
import { SystemNotificationsChecklists2Component } from '@fi-app/system-notifications/checklists2/checklists2.component';
import { Checklists2SystemNotificationsService } from '@fi-app/system-notifications/checklists2/checklists2-system-notifications.service';
import { FiChecklist2ListColumnDefsModule } from '@fi-shared/checklist/fi-checklist2-list-column-defs/fi-checklist2-list-column-defs.module';
import { SystemNotificationsAuditChecklists2Component } from '@fi-app/system-notifications/auditChecklists2/audit-checklists2.component';
import { SystemNotificationsTasks2Component } from '@fi-app/system-notifications/tasks2/tasks2.component';
import { FiTaskV2SharedComponentsModule } from '@fi-app/task-v2/components/fi-task-v2-shared-components.module';
import { FiSystemNotificationsOnboardingsComponent } from '@fi-app/system-notifications/onboardings/fi-system-notifications-onboardings.component';
import { FiTooltipModule } from '@fi-shared/fi-tooltip/fi-tooltip.module';
import { FiOnboardingProgressBarModule } from '@fi-app/fi-onboarding/fi-onboarding-progress-bar/fi-onboarding-progress-bar.module';

@NgModule({
    imports: [
        CommonModule,
        MatTabsModule,
        ItemsListModule,
        UtilitiesModule,
        ChecklistModule,
        FiWrapperTableModule,
        MatSortModule,
        MatTableModule,
        MatButtonModule,
        FiProfileIconModule,
        MatIconModule,
        UserRequestsAccessModule,
        FiChecklist2ListColumnDefsModule,
        FiTaskV2SharedComponentsModule,
        FiTooltipModule,
        FiOnboardingProgressBarModule,
    ],
    declarations: [
        SystemNotificationsChecklistsComponent,
        SystemNotificationsChecklists2Component,
        SystemNotificationsAuditChecklists2Component,
        SystemNotificationsAutosavedComponent,
        SystemNotificationsCheckpointAnswerComponent,
        SystemNotificationsTabsComponent,
        FiSystemNotificationsBlockComponent,
        FiSystemNotificationsOnboardingsComponent,
        SystemNotificationsRequestAccessComponent,
        SystemNotificationsFormsComponent,
        SystemNotificationsTasksComponent,
        SystemNotificationsTasks2Component,
    ],
    providers: [SystemNotificationsService, Checklists2SystemNotificationsService, ChecklistsReminderService],
    exports: [FiSystemNotificationsBlockComponent],
})
export class SystemNotificationsModule {}
